import React from 'react'

const ActionButtons = (props) => {
  return (
    <ul className={"nav navbar-nav " + (props.className || "")}>
      <li>
        <div className="navbar-actions">
          {props.actions.map((action, index) =>
            <a key={'header-action-'+index}
               href={action.url} className={`btn ${index === props.actions.length - 1 ? "btn-primary" : "btn-outline-default"}`}>
              {action.title}
            </a>
          )}
        </div>
      </li>
    </ul>
  )
}

export default ActionButtons


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/header/action-buttons/index.js